<template>
  <section id="roadmap" class="tf-section tf-roadmap">
        <div class="overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="tf-title m-b30" data-aos="fade-up" data-aos-duration="800">
                        <p class="h8 sub-title">ROADMAP</p>
                        <h4 class="title">Heaphetus Timeline</h4>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="roadmap scrol">
                        <div class="box box-left">
                            <div class="rm-box style" data-aos="fade-right" data-aos-duration="1200">
                                <div class="corner-box">
                                    <h5>Q2 2022</h5>
                                    <ul>
                                        <li>Aenean tempor</li>
                                        <li>Fusce arcu maecenas</li>
                                        <li>Malesuada felis sem elementum</li>
                                        <li>Risus eu metus</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="rm-box" data-aos="fade-right" data-aos-duration="1200">
                                <div class="corner-box">
                                    <h5>Q4 2021</h5>
                                    <ul>
                                        <li>Aenean tempor</li>
                                        <li>Fusce arcu maecenas</li>
                                        <li>Malesuada felis sem elementum</li>
                                        <li>Risus eu metus</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="rm-box" data-aos="fade-right" data-aos-duration="1200">
                                <div class="corner-box">
                                    <h5>Q2 2021</h5>
                                    <ul>
                                        <li>Aenean tempor</li>
                                        <li>Fusce arcu maecenas</li>
                                        <li>Malesuada felis sem elementum</li>
                                        <li>Risus eu metus</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="box box-right">
                            <div class="rm-box style" data-aos="fade-left" data-aos-duration="1200">
                                <div class="corner-box">
                                    <h5>Q1 2022</h5>
                                    <ul>
                                        <li>Release website and logo</li>
                                        <li>Grow community</li>
                                        <li>Launch the project</li>
                                        <li>Social media setup</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="rm-box" data-aos="fade-left" data-aos-duration="1200">
                                <div class="corner-box">
                                    <h5>Q3 2021</h5>
                                    <ul>
                                        <li>Aenean tempor</li>
                                        <li>Fusce arcu maecenas</li>
                                        <li>Malesuada felis sem elementum</li>
                                        <li>Risus eu metus</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="mb-0 rm-box" data-aos="fade-left" data-aos-duration="1200">
                                <div class="corner-box">
                                    <h5>Q1 2021</h5>
                                    <ul>
                                        <li>Aenean tempor</li>
                                        <li>Fusce arcu maecenas</li>
                                        <li>Malesuada felis sem elementum</li>
                                        <li>Risus eu metus</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'RoadmapComponent'
}
</script>

<style>

</style>